import { motion } from 'framer-motion';
import useCountUp from '@hooks/useCountUp';
import './Statistics.css';

const Statistics = () => {
  // Initialize counters with useCountUp hook
  const clientsCounter = useCountUp(2000, 10, 'easeOut');
  // const codeCounter = useCountUp(56841, 2500, 'easeOut');
  const projectsCounter = useCountUp(150, 5, 'easeOut');
  // const coffeeCounter = useCountUp(874, 2500, 'easeOut');

  const stats = [
    {
      id: 1,
      count: clientsCounter.count,
      ref: clientsCounter.ref,
      label: 'Clients Served',
      icon: 'bi-person',
      color: '#3498db',
    },
    // {
    //     id: 2,
    //     count: codeCounter.count,
    //     ref: codeCounter.ref,
    //     label: 'Lines of Code',
    //     icon: 'bi-code',
    //     color: '#e74c3c'
    // },
    {
      id: 3,
      count: projectsCounter.count,
      ref: projectsCounter.ref,
      label: 'No. of Projects',
      icon: 'bi-briefcase',
      color: '#16a085',
    },
    // {
    //     id: 4,
    //     count: coffeeCounter.count,
    //     ref: coffeeCounter.ref,
    //     label: 'Cups of Coffee',
    //     icon: 'bi-cup',
    //     color: '#9b59b6'
    // }
  ];

  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.1,
        duration: 0.5,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <section className="statistics-section">
      <div className="statistics-container">
        <div className="statistics-header">
          <h2 className="statistics-title">Our Achievements</h2>
          <p className="statistics-subtitle">
            Numbers that speak for our excellence and dedication
          </p>
        </div>

        <div className="statistics-grid">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.id}
              ref={stat.ref}
              className="stat-card"
              style={{ '--stat-color': stat.color }}
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={cardVariants}
            >
              <div className="stat-icon">
                <i className={stat.icon}></i>
              </div>
              <div className="stat-number">{stat.count.toLocaleString()}</div>
              <div className="stat-label">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Statistics;
